import * as React from "react";

interface NothingToSeeHereProps {
    content: string;
}

import styles = require("./style.less");
export class NothingToSeeHere extends React.Component<NothingToSeeHereProps, any> {
    render() {
        return <p className={styles.content}>{this.props.content}</p>;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/NothingToSeeHere/NothingToSeeHere.tsx